import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  divContainer: {
    display: 'flex',
    width: '85%',
    flexDirection: 'column',
    margin: '70px auto',
    fontFamily: 'Roboto'
  },

  divSeconderyContainer: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: 0,
    },
  },

  divColumn: {
    marginLeft: '10px',
  },

  spanLink: {
    textDecoration: 'underline',
  },
  anchorPlikiPdf: {
    color: '#3560ff',
    textDecoration: 'underline',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'end',
  },
  spanAddPdf: {
    margin: '0px 5px 0px -4px',
    fontSize: '20px',
  },
  buttonAddPdf: {
    color: '#fff',
    height: '30px',
    backgroundColor: '#3f51b5',
  },

  noAvailableFilesHeader: {
    marginLeft: '10px',
  },
}));

export { useStyles };
